import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import checkmarkIcon from '@getgo/chameleon-icons/dist/rebranded/checkbox-check.svg';
import indeterminateIcon from '@getgo/chameleon-icons/dist/rebranded/checkbox-line.svg';
import '../synapse-icon/synapse-icon.js';
import checkboxStyles from '../../styles/synapse-checkbox.js';
export class SynapseCheckbox extends LitElement {
    static get properties() {
        return {
            isChecked: { type: Boolean },
            isDisabled: { type: Boolean, attribute: 'disabled', reflect: true },
            indeterminate: { type: Boolean, attribute: 'indeterminate' },
            labelText: { type: String, attribute: 'label-text' },
            leadingLabel: { type: Boolean, attribute: 'leading-label' },
            isLarge: { type: Boolean, attribute: 'large' },
            defaultChecked: {
                type: Boolean,
                attribute: 'default-checked',
                converter: value => value === "true"
            }
        };
    }
    static get styles() {
        return [checkboxStyles];
    }
    constructor() {
        super();
        this.labelText = '';
        this.isChecked = false;
        this.leadingLabel = false;
        this.defaultChecked = false;
        this.indeterminate = false;
        this.isLarge = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.defaultChecked) {
            this.isChecked = true;
        }
    }
    handleClick(event) {
        event.preventDefault();
        const oldValue = this.isChecked;
        this.isChecked = !oldValue;
        this.dispatchEvent(new CustomEvent('change', {
            detail: {
                wasChecked: oldValue,
                isChecked: this.isChecked
            }
        }));
    }
    render() {
        const label = this.labelText ? html `<div>${this.labelText}</div>` : '';
        return html `
      <div class=${classMap({
            'checkbox-container': true,
            disabled: this.isDisabled,
            large: this.isLarge,
        })}>
        <input type='checkbox' ?checked=${this.isChecked} />
        <label @click=${this.handleClick}>
          ${this.leadingLabel ? label : ''}
          <span>${this.renderIcon()}</span>
          ${!this.leadingLabel ? label : ''}
        </label>
      </div>`;
    }
    renderIcon() {
        return html `
      <synapse-icon svg="${this.indeterminate ? indeterminateIcon : checkmarkIcon}">
      </synapse-icon>
    `;
    }
}
customElements.define('synapse-checkbox', SynapseCheckbox);
